<template>
  <home-page v-if="!appUnderMaintenance"></home-page>
  <div
    v-else
    class="under-maintenance"
  >
    <p>{{ appUnderMaintenanceMessage }}</p>
  </div>
</template>

<script>
import moment from 'moment';
import HomePage from '../components/home-page/index.vue';

export default {
  components: { HomePage },
  data() {
    return { appUnderMaintenanceMessage: process.env.VUE_APP_UNDER_MAINTENANCE_MSG };
  },
  computed: {
    appUnderMaintenance() {
      return moment()
        .isBetween(new Date(process.env.VUE_APP_UNDER_MAINTENANCE_START), new Date(process.env.VUE_APP_UNDER_MAINTENANCE_END));
    },
  },
};

</script>

<style>
.under-maintenance {
  text-align: center;
  margin: 90px;
  padding: 25px;
  background-color: #00ad68;
  font-size: 24px;
  color: white;
}
</style>
